import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class LoginSignupService {

    constructor(private http: HttpClient) { }

    signInWithEmailAndPassword(email: string, password: string): Observable<any> {
        const apiUrl = `${environment.apiUrl}api/supabase/signin`;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        return this.http.post(apiUrl, { email, password }, { headers });
    }

    registerUser(userData: any): Observable<any> {
        const apiUrl = `${environment.apiUrl}api/supabase/signup`;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        return this.http.post(apiUrl, userData, { headers });
    }


    getUserbyAccessToken(token: string, refreshToken: string): Observable<any> {
        const apiUrl = `${environment.apiUrl}api/supabase/user`;
        let params = new HttpParams();
        params = params.set('refreshToken', refreshToken);
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + token
        });

        return this.http.get(apiUrl, { headers, params });
    }


    getUserByID(id: string): Observable<any> {
        const apiUrl = `${environment.apiUrl}api/supabase/customer/${id}`;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        return this.http.get(apiUrl, { headers });
    }

    logoutUser(token: string, refreshToken: string): Observable<any> {
        const apiUrl = `${environment.apiUrl}api/supabase/signout`;
        let params = new HttpParams();
        params = params.set('refreshToken', refreshToken);
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + token
        });

        return this.http.post(apiUrl, {}, { headers, params });
    }
}